import { Component , HostBinding, OnInit} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import * as $ from 'jquery';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { UserAuthService } from '../services/user-auth.service';
import { NgIf } from '@angular/common';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { Guid } from 'guid-typescript';
import { LogoComponent } from '../logo/logo.component';

@Component({
    selector: 'app-register-header',
    templateUrl: './register-header.component.html',
    styleUrls: ['./register-header.component.css'],
    standalone: true,
    imports: [TrackingDirective, RouterLink, NgIf, LogoComponent]
})
export class RegisterHeaderComponent implements OnInit {
  @HostBinding('style.width') public readonly WIDTH = '100%';
  userData: any = null;
  title = 'webapp';
  
  constructor(
    public readonly router: Router,
    private readonly cookieService: CookieService,
    private readonly userAuthService: UserAuthService,
    private readonly oauthService: OAuthService
  ) { }

  ngOnInit(): void {
    this.userData = this.userAuthService.getIdentityClaims();
    this.toogleStitchProfileMenu();
  }

  toogleStitchProfileMenu() {
    const fn = () => {
      const isStitchEnabled = localStorage.getItem('isStitchEnabled');
      if (isStitchEnabled && JSON.parse(isStitchEnabled)) {
        $('#liStitchAccounts').show();
      } else {
        $('#liStitchAccounts').hide();
      }
    };

    setInterval(() => {
      fn();
    }, 2000);

    fn();
  }

  logout() {
    (window as any).fcWidget.destroy();
    this.cookieService.delete('submissionId', '/');
    this.cookieService.delete('userId', '/');
    this.userAuthService.logOut();
  }

  azureAdlogin() {
    let submissionId = '';
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    const submissionCode = Guid.create().toString();
    this.oauthService.initLoginFlow('', { submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
      instrumentationKey: environment.appInsights.instrumentationKey });
  }
}


